import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionId } from "../../../../../../utils/tokenHandlers";
import { getIdfromEmail } from "../../apis/getIdfromEmail";

export const getIdfromEmailAction = createAsyncThunk(
  "getIdfromEmailAction",
  async ({ username, token }: { username: string; token: string }) => {
    return getIdfromEmail(username, token).then((response: any) => {
      return response.data;
    });
  }
);
